import { makeAutoObservable } from 'mobx';

import type { Optional, SubscriptionOrderData } from 'chaika-frontend-types/frontend-cms';

import { SubscriptionOrdersList } from './SubscriptionOrdersList';
import { SubscriptionList } from '@store/models/SubscriptionList';

class SubscriptionOrderStore {
    public subscriptionOrdersList = new SubscriptionOrdersList();
    public subscriptionAdditionalDataList = new SubscriptionList();

    constructor() {
        makeAutoObservable(this, undefined, { autoBind: true });
    }

    public getByBuyerId(buyerId: string): SubscriptionOrderData[] {
        return this.subscriptionOrdersList.values.filter(it => it.buyerId === buyerId);
    }

    public getByPatientId(patientId: string): SubscriptionOrderData[] {
        return this.subscriptionOrdersList.values.filter(it => it.patientId === patientId);
    }

    public getById(subscriptionOrderId: string): Optional<SubscriptionOrderData> {
        return this.subscriptionOrdersList.get(subscriptionOrderId);
    }

    public set(subscriptionOrders: SubscriptionOrderData[]): void {
        this.subscriptionOrdersList = new SubscriptionOrdersList(subscriptionOrders);
    }

    public update(subscriptionOrderId: string, params: Partial<SubscriptionOrderData>): void {
        const subscriptionOrder = this.subscriptionOrdersList.getExisting(subscriptionOrderId);

        this.subscriptionOrdersList.update(subscriptionOrderId, { ...subscriptionOrder, ...params });
    }
}

export const subscriptionOrderStore = new SubscriptionOrderStore();
